import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import { push } from 'react-router-redux';
import Redirect from 'react-router/Redirect';
import Spinner from 'react-spinkit';
import { branch, compose, lifecycle, renderComponent, withProps, withStateHandlers } from "recompose";
import { bindActionCreators } from 'redux';
import { dateFormats, routes } from '../../../../constants';
import { isBusinessAdmin } from '../../../../services';
import { contentConfigSelector } from '../../../../state/modules/configuration/selectors';
import { taskActions } from '../../../../state/modules/task';
import { currentUserSelector } from '../../../../state/modules/user';
import { noCapMap, toSafeExternalUrl } from '../../../../utils';
import { Icon, InputFormField } from '../../../components';
import Loading from '../../loading';
import ContentTile from '../partials/content-tile';
import { taskTypes } from './config';
import { isValid, validate } from './validation';

const TaskReview = ({
  cpdCategorys,
  assignTask,
  config,
  assignedUsers,
  isAssigningTask,
  deselectContent,
  task: {
    taskDetails,
    ...task
  },
  validation
}) => (<div id="task-review">
  <Grid>
    <Row className='no-gutter'>
      <Col xs={12} md={10} mdOffset={1} className='no-padding'>
        <h1 className="text-center">
          Review your task
        </h1>
      </Col>
    </Row>
    <Row className='no-gutter bottom-gap'>
      <Col xs={12} md={10} mdOffset={1} className='no-padding'>
        <h3 className='text-center'>
          You want the following people to complete the below <span className='highlight'>{task.type === taskTypes.CADDIE ? 'Caddie Content' : task.type === taskTypes.EXTERNAL ? 'external link' : 'attachment'}</span> by <span className='highlight'>{dateFnsCompat.format(taskDetails.dueDate, dateFormats.ShortMonthLongDate)}</span>:
        </h3>
      </Col>
      {
        assignedUsers.length > 0 ?
          <Col xs={12} md={10} mdOffset={1} className='no-padding text-center'>
            <p>{setUpUserText(assignedUsers)}</p>
          </Col>
          : null
      }
    </Row>
    <Row className='no-gutter'>
      {
        task.type === taskTypes.EXTERNAL ?
          <Col xs={12}>
            <InputFormField {...{
              value: taskDetails.externalLink,
              inputProps: { disabled: true },
            }} />
            <a href={toSafeExternalUrl(taskDetails.externalLink) || undefined} target="_blank">{taskDetails.externalLink}</a>
          </Col> : null
      }
      {
        task.type === taskTypes.CADDIE ? noCapMap((chunk, chunkIndex) =>
          <Row key={chunkIndex} className='card-gutter row-slider bottom-gap'>
            {
              noCapMap((content, index) =>
                <Col key={index} xs={12} md={3}>
                  <ContentTile {...content} openInNewWindow={true} removeContentHandler={() => deselectContent(content)} />
                </Col>
              )(chunk)
            }
          </Row>
        )(fp.flow(
          fp.chunk(4)
        )(taskDetails.selectedContents)) : null
      }
      {
        validation.selectedContents ?
          <Row className='no-gutter'>
            <Col xs={12} className='bottom-gap'>
              <div aria-invalid='true' className="has-error text-center">
                <span>
                  {validation.selectedContents}
                </span>
                <LinkContainer className='top-gap' to={routes.app.tasks.details}>
                  <Button>
                    <Icon icon='add-large' /> Add Content
                    </Button>
                </LinkContainer>
              </div>
            </Col>
          </Row> : null
      }
      {
        task.type === taskTypes.ATTACHMENT ?
          noCapMap(
            (file, index) => <Col xs={12} key={index}>
              <a href={file.preview} className='flex-center linkBox' target="_blank">
                {file.name}
              </a>
            </Col>
          )(taskDetails.files) : null
      }
    </Row>
    {
      taskDetails.description && (taskDetails.description.length > 0) ?
        <Row className='no-gutter'>
          <Col xs={12} md={8} mdOffset={2} className='no-padding text-left'>
            <h2>
              Task Details:
          </h2>
          </Col>
          <Col xs={12} md={8} mdOffset={2} className='no-padding text-left'>
            <p>{taskDetails.description}</p>
          </Col>
        </Row> : null
    }
    <Row className='no-gutter bottom-gap'>
      {
        validation.selectedContents ? null :
          <Col xs={12} className='flex-center'>
            <Button onClick={assignTask}>
              {
                isAssigningTask ?
                  <Spinner name='circle' className='spinner' fadeIn='none' /> :
                  'Assign Task'
              }
            </Button>
          </Col>
      }
      <Col xs={12} mdOffset={2} className='no-padding'>
        <LinkContainer to={routes.app.tasks.details}>
          <Button bsStyle="plain">Go back to previous step.</Button>
        </LinkContainer>
      </Col>
    </Row>
  </Grid>
</div>);

const setUpUserText = (assignedUsers) =>
  noCapMap((user, index) =>
    <span key={user.id}>
      {assignedUsers.length === 1 ?
        <b>{he.decode(user.fullName)}</b> :
        index === assignedUsers.length - 2 ?
          <b>{he.decode(user.fullName)} </b> :
          index === assignedUsers.length - 1 ?
            <span>and <b>{he.decode(user.fullName)}</b></span> :
            <span><b>{he.decode(user.fullName)}</b>, </span>}
    </span>
  )(assignedUsers)

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  isBusinessAdmin: isBusinessAdmin(state.user.currentUser),
  cpdCategorys: state.industry.cpdCategorys,
  task: state.task.createTask,
  config: contentConfigSelector(state),
  isAssigningTask: state.task.isAssigningTask
});

const mapDispatchToProps = (dispatch) => ({
  assignTask: bindActionCreators(taskActions.task.assignTask, dispatch),
  setTaskDetails: bindActionCreators(taskActions.task.setTaskDetails, dispatch),
  goTo: bindActionCreators(push, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ task }) => !(task && task.type),
    renderComponent(() => <Redirect to={routes.app.tasks.details} />)
  ),
  branch(
    ({ isBusinessAdmin }) => !isBusinessAdmin,
    renderComponent(Loading)
  ),
  withStateHandlers(
    ({ task }) => ({
      task
    }),
    {
      deselectContent: ({ task }) => (content) => ({
        task: {
          ...task,
          taskDetails: {
            ...task.taskDetails,
            selectedContents: fp.filter(
              c => c.id !== content.id
            )(task.taskDetails.selectedContents)
          }
        }
      })
    }
  ),
  withStateHandlers(
    {
      validation: {}
    },
    {
      setValidation: () => (validation) => ({
        validation
      })
    }
  ),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        task: {
          type,
          allocateCpd,
          taskDetails
        },
        setValidation,
        validation
      } = nextProps;

      if (isValid(validation)) {
        const nextValidation = validate(taskDetails, type, allocateCpd, true, {})
        if (!isValid(nextValidation)) {
          setValidation(nextValidation)
        }
      }
    }
  }),
  withProps(
    ({ task, assignTask, goTo, setValidation, setTaskDetails, user }) => ({
      assignTask: () => {
        const {
          type,
          allocateCpd,
          taskDetails
        } = task;
        setTaskDetails(taskDetails);
        const validation = validate(taskDetails, type, allocateCpd, true, {})
        if (isValid(validation)) {
          assignTask(task, user);
        } else {
          setValidation(validation)
        }
      }
    })
  ),
  withProps(
    ({ task: { taskDetails } }) => ({
      assignedUsers: fp.filter(
        ({ selected }) => selected
      )(taskDetails.users)
    })
  )
)(TaskReview)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/task-review.js